import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

// Firebase credentials for KStore
// You can replace these with your project's credentials from Firebase Console -> Project Settings
export const firebaseConfig = {
  apiKey: "AIzaSyBbZWEwYMUGd3ncSTuNykwQjz_Bnyikhlo",
  authDomain: "kstore-b0b76.firebaseapp.com",
  projectId: "kstore-b0b76",
  storageBucket: "kstore-b0b76.firebasestorage.app",
  messagingSenderId: "196979227351",
  appId: "1:196979227351:web:f66f96ecb65df2bf368e92",
  measurementId: "G-K9RBWBRTJH"
};

// VAPID Public Key generated from Firebase Console -> Cloud Messaging -> Web Push certificates
export const VAPID_KEY = "BHox8IX9k2joF4nz3nYHeYFcxbd3daK7SWUgpmlNsFpBohtnHSg04Ib8pU-N-y_YQzGPd_xgTFZ-XVkEQLYMKL8";

// Initialize Firebase App singleton
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

/**
 * Register or get the Firebase Messaging Service Worker.
 * Ensures the service worker is active so push works even in killed/background state.
 */
export const registerMessagingServiceWorker = async () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    console.warn("Service workers are not supported in this browser.");
    return null;
  }

  try {
    const swUrl = `${process.env.PUBLIC_URL || ""}/firebase-messaging-sw.js`;
    let registration = await navigator.serviceWorker.getRegistration("/");
    if (!registration) {
      registration = await navigator.serviceWorker.register(swUrl, { scope: "/" });
    }
    // Race against a short timeout so navigator.serviceWorker.ready never hangs on cold starts
    const readyPromise = navigator.serviceWorker.ready;
    const timeoutPromise = new Promise((resolve) => setTimeout(() => resolve(registration), 3000));
    const activeReg = await Promise.race([readyPromise, timeoutPromise]);
    console.log("Firebase Messaging SW registered successfully with scope:", (activeReg || registration)?.scope);
    return activeReg || registration;
  } catch (error) {
    console.error("Failed to register firebase-messaging-sw.js:", error);
    return null;
  }
};

/**
 * Request notification permission from the user and retrieve the FCM device token.
 */
export const requestNotificationPermission = async () => {
  try {
    if (typeof window === "undefined" || !("Notification" in window)) {
      console.warn("This browser does not support desktop notifications.");
      return null;
    }

    // 1. MUST request permission IMMEDIATELY within active user gesture.
    // In Chromium / Android PWA, calling any async task before Notification.requestPermission()
    // causes transient activation to expire, which blocks the system permission prompt.
    let permission = Notification.permission;
    if (permission !== "granted") {
      permission = await Notification.requestPermission();
    }

    if (permission !== "granted") {
      console.warn("Notification permission was not granted:", permission);
      return null;
    }

    // 2. Check Firebase Messaging support after permission is requested
    const supported = await isSupported();
    if (!supported) {
      console.warn("Firebase Messaging is not supported on this browser/platform.");
      return null;
    }

    // 3. Ensure SW is active & obtain token
    const registration = await registerMessagingServiceWorker();
    const messaging = getMessaging(app);

    const tokenOptions = {
      vapidKey: VAPID_KEY,
    };
    if (registration) {
      tokenOptions.serviceWorkerRegistration = registration;
    }

    // Timeout protection so login or subscription is never blocked indefinitely
    const tokenPromise = getToken(messaging, tokenOptions);
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("FCM getToken timeout")), 8000)
    );

    const currentToken = await Promise.race([tokenPromise, timeoutPromise]);
    if (currentToken) {
      console.log("FCM Device Registration Token received:", currentToken);
      if (typeof window !== "undefined") {
        localStorage.setItem("kstore_fcm_token", currentToken);
      }
      return currentToken;
    } else {
      console.warn("No registration token available. Request permission to generate one.");
      return null;
    }
  } catch (err) {
    if (
      err?.name === "NotAllowedError" ||
      err?.message?.includes("denied push permission") ||
      err?.code === "messaging/permission-blocked"
    ) {
      console.warn(
        "FCM Token generation note: On iOS, Web Push is only supported on physical devices (not in the iOS Simulator) and only when running from the Home Screen PWA."
      );
    }
    console.error("An error occurred while retrieving token:", err);
    if (typeof window !== "undefined") {
      const cached = localStorage.getItem("kstore_fcm_token");
      if (cached) return cached;
    }
    return null;
  }
};

/**
 * Listener for foreground messages when website tab is open.
 */
export const subscribeForegroundMessages = async (callback) => {
  try {
    const supported = await isSupported();
    if (!supported) return () => {};

    const messaging = getMessaging(app);
    return onMessage(messaging, (payload) => {
      if (typeof callback === "function") {
        callback(payload);
      }
    });
  } catch (err) {
    console.warn("Foreground message subscription warning:", err);
    return () => {};
  }
};

export const onMessageListener = () =>
  new Promise(async (resolve, reject) => {
    try {
      const supported = await isSupported();
      if (!supported) return;

      const messaging = getMessaging(app);
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    } catch (err) {
      reject(err);
    }
  });

export { app };
